// import DeepTable from 'slate-deep-table';
import sortCitationsReferences from '../citationsReferencesAlgorithm/sortCitationsReferences';
import actionOnExpandedSelection from './plugins/Xscript/actionOnExpandedSelection';
import toggleMUTSMark from './toggleMUTSMark';

export const MarkHotkey = (options) => {
  const { type, key, highLightSubscript, highLightSuperscript } = options;
  return {
    onKeyDown(event, editor, next) {
      if (!(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== key)
        return next();
      /**
       * remove current mark before applying new mark
       *
       */
      event.preventDefault();
      if (type === 'subscript') {
        highLightSubscript();
        actionOnExpandedSelection(editor, () => {
          editor.removeMark('superscript');
          editor.toggleMark('subscript');
        });
      } else if (type === 'superscript') {
        highLightSuperscript();
        actionOnExpandedSelection(editor, () => {
          editor.removeMark('subscript');
          editor.toggleMark('superscript');
        });
      } else {
        toggleMUTSMark({ editor, type });
      }
      return true;
    },
  };
};

const sortCitationsPlugin = {
  commands: {
    sortCitationsReferences(
      _editor,
      editorRefs,
      references,
      handleUpdateReferences,
      updateSlateEditorsValue,
    ) {
      sortCitationsReferences(
        editorRefs,
        references,
        handleUpdateReferences,
        updateSlateEditorsValue,
      );
    },
  },
};

export const BasicMarks = [
  MarkHotkey({ key: 'b', type: 'bold' }),
  MarkHotkey({ key: '`', type: 'code' }),
  MarkHotkey({ key: 'i', type: 'italic' }),
  MarkHotkey({ key: '~', type: 'strikethrough' }),
  MarkHotkey({ key: 'u', type: 'underline' }),
];

const getPlugins = (highLightSubscript, highLightSuperscript) => {
  const plugins = [
    ...BasicMarks,
    MarkHotkey({
      key: '=',
      type: 'subscript',
      highLightSubscript,
    }),
    MarkHotkey({
      key: '+',
      type: 'superscript',
      highLightSuperscript,
    }),
    sortCitationsPlugin,
    // DeepTable({
    //   typeTable: 'table',
    //   typeRow: 'table_row',
    //   typeCell: 'table_cell',
    //   typeContent: 'paragraph',
    // }),
  ];
  return plugins;
};

// Create an array of plugins.
export default getPlugins;
